import React from 'react'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import ProfileHelper from 'helpers/profile'

function DatePickerInput(props) {
  let errorStatus = false
  let errorMessage = ''

  const {
    input: { name, onChange, value, ...restInput },
    meta: { submitError, touched, error },
    label,
    required,
    disabled,
    variant,
    autoOk,
    ...rest
  } = props
  const locale = ProfileHelper.getCurrentLocale()

  if (touched && (error || submitError)) {
    errorStatus = true
    errorMessage = error || submitError
  }

  return (
    <div className="form-group">
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
        <DatePicker
          {...rest}
          fullWidth
          name={name}
          label={label}
          required={required}
          disabled={disabled}
          helperText={errorMessage}
          error={errorStatus}
          inputProps={restInput}
          onAccept={onChange}
          variant={variant}
          autoOk={autoOk}
          format="dd/MM/yyyy"
          maxDate={Date.now()}
          value={value === '' ? null : value}
        />
      </MuiPickersUtilsProvider>
    </div>
  )
}

export default DatePickerInput
